/** InsCoder 2026-04-03 B + Custom cart discount logic with event delegation **/
(function() {
  const invalidCodeTextEl = document.querySelector('.cust-cart-discount-error');
  const INVALID_CODE_MESSAGE = invalidCodeTextEl && invalidCodeTextEl.textContent && invalidCodeTextEl.textContent.trim() !== ''
    ? invalidCodeTextEl.textContent.trim()
    : 'Invalid Code Entered';

  document.addEventListener('click', handleDiscountClick);
  document.addEventListener('input', handleDiscountInput);
  document.addEventListener('keypress', handleDiscountKeypress);
  markAutomaticDiscountItems();

  let pendingRemoveBtn = null;
  let isDiscountLoading = false;

  // 功能：统一处理折扣模块点击事件（展开、清空、应用）
  async function handleDiscountClick(e) {
    const removeAppliedBtn = e.target.closest('.cust-cart-applied-discount-remove-btn');
    if (removeAppliedBtn) {
      e.preventDefault();
      const discountItem = removeAppliedBtn.closest('.cust-cart-applied-discount-item');
      const discountNameEl = discountItem ? discountItem.querySelector('.cust-cart-applied-discount-name') : null;
      const discountName = discountNameEl ? discountNameEl.textContent.trim() : '';

      const popup = document.querySelector('.cust-cart-discount__popup');
      const popupCode = document.querySelector('.cust-cart-discount__popup-code');
      if (popup && popupCode) {
        popup.__originalParent = popup.__originalParent || popup.parentElement;
        if (popup.parentElement !== document.body) {
          document.body.appendChild(popup);
        }
        popupCode.textContent = discountName;
        popup.style.display = 'flex';
        pendingRemoveBtn = removeAppliedBtn;
      } else {
        await removeAppliedDiscount(removeAppliedBtn);
      }
      return;
    }

    const popupCancel = e.target.closest('.cust-cart-discount__popup-btn--cancel') || 
                        e.target.closest('.cust-cart-discount__popup-close') || 
                        (e.target.classList && e.target.classList.contains('cust-cart-discount__popup-overlay'));
    if (popupCancel) {
      e.preventDefault();
      e.stopPropagation();
      closeAllDiscountPopups();
      pendingRemoveBtn = null;
      return;
    }

    const popupConfirm = e.target.closest('.cust-cart-discount__popup-btn--confirm');
    if (popupConfirm) {
      e.preventDefault();
      e.stopPropagation();
      closeAllDiscountPopups();
      if (pendingRemoveBtn) {
        await removeAppliedDiscount(pendingRemoveBtn);
        pendingRemoveBtn = null;
      }
      return;
    }

    const header = e.target.closest('.cust-cart-discount__header');
    const discountArrow = e.target.closest('.discount-arrow');
    if (header || discountArrow) {
      toggleDiscountContent(header || discountArrow);
      return;
    }

    const clearBtn = e.target.closest('.cust-cart-discount__clear');
    if (clearBtn) {
      clearDiscountInput(clearBtn);
      return;
    }

    const applyBtn = e.target.closest('#cust-cart-discount-btn, .cust-cart-discount__apply');
    if (applyBtn) {
      await applyDiscountCode(applyBtn);
    }
  }
  // 功能：移除已应用折扣
  async function removeAppliedDiscount(removeBtn) {
    const discountArea = removeBtn.closest('.cust-cart-discount');
    const context = getDiscountContext(discountArea);
    if (!context || isDiscountLoading) return;
    const flowId = `remove-${Date.now()}`;

    try {
      setDiscountLoading(context, true);
      logDiscountFlow(flowId, 'Start removing discount');
      const beforeCart = await requestCartSnapshot();
      const beforeCodeList = getDiscountCodeList(beforeCart);
      logDiscountFlow(flowId, 'Cart snapshot before removing', {
        hasDiscountCodeBefore: beforeCodeList.length > 0,
        discountCodeListBefore: beforeCodeList,
        cart: summarizeCart(beforeCart)
      });
      const removeTargetCode = resolveRemoveTargetCode(removeBtn, beforeCodeList);
      const removalResult = removeSingleCodeFromList(beforeCodeList, removeTargetCode);
      if (removalResult.removedCodes.length === 0) {
        logDiscountFlow(flowId, 'Remove failed: no matching discount code in cart', {
          removeTargetCode: removeTargetCode,
          discountCodeListBefore: beforeCodeList
        });
        setDiscountLoading(context, false);
        showMessage(context.messageEl, 'Failed to remove discount', 'error');
        return;
      }

      const clearResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: removalResult.remainingCodes.join(',') })
      });
      const clearBody = await parseJsonSafe(clearResponse);
      logDiscountFlow(flowId, 'Clear discount request response', {
        status: clearResponse.status,
        requestOk: clearResponse.ok,
        ok: clearResponse.ok,
        redirected: clearResponse.redirected,
        url: clearResponse.url,
        beforeCodes: beforeCodeList,
        removedCodes: removalResult.removedCodes,
        nextCodes: removalResult.remainingCodes,
        cart: summarizeCart(clearBody)
      });

      const afterCart = await requestCartSnapshot();
      const afterCodeList = getDiscountCodeList(afterCart);
      const hasCodeAfterClear = removalResult.removedCodes.some(function(code) {
        return includesDiscountCode(afterCodeList, code);
      });
      logDiscountFlow(flowId, 'Cart snapshot after clear request', {
        hasCodeAfterClear: hasCodeAfterClear,
        discountCodeListAfterClear: afterCodeList,
        cart: summarizeCart(afterCart)
      });

      if (!hasCodeAfterClear) {
        logDiscountFlow(flowId, 'Remove success, refresh cart drawer');
        closeAllDiscountPopups();
        await refreshCartDrawer();
        return;
      }

      logDiscountFlow(flowId, 'Remove failed: discount codes still exist');
      closeAllDiscountPopups();
      setDiscountLoading(context, false);
      showMessage(context.messageEl, 'Failed to remove discount', 'error');
    } catch (error) {
      closeAllDiscountPopups();
      setDiscountLoading(context, false);
      showMessage(context.messageEl, 'Failed to remove discount', 'error');
      logDiscountFlow(flowId, 'Remove flow exception', error);
      console.log('[cust-cart-discount] remove discount error', error);
    }
  }

  // 功能：输入时同步按钮可点击状态和清空按钮显示状态
  function handleDiscountInput(e) {
    if (!e.target.classList.contains('cust-cart-discount__input')) return;
    const input = e.target;
    const discountArea = input.closest('.cust-cart-discount');
    if (!discountArea) return;
    const applyBtn = discountArea.querySelector('.cust-cart-discount__apply');
    const hasValue = input.value.trim().length > 0;

    input.classList.toggle('has-value', hasValue);
    if (applyBtn) applyBtn.classList.toggle('is-ready', hasValue);
  }

  // 功能：输入框回车时触发应用折扣按钮
  function handleDiscountKeypress(e) {
    if (e.key !== 'Enter' || !e.target.classList.contains('cust-cart-discount__input')) return;
    e.preventDefault();
    const discountArea = e.target.closest('.cust-cart-discount');
    if (!discountArea) return;
    const applyBtn = discountArea.querySelector('.cust-cart-discount__apply');
    if (applyBtn) applyBtn.click();
  }

  // 功能：切换折扣区域展开/收起状态
  function toggleDiscountContent(triggerEl) {
    const discountArea = triggerEl.closest('.cust-cart-discount') || document.querySelector('.cust-cart-discount');
    if (!discountArea) return;
    const content = discountArea.querySelector('.cust-cart-discount__content');
    if (!content) return;

    const isExpanded = content.style.display !== 'none';
    content.style.display = isExpanded ? 'none' : 'flex';
    discountArea.classList.toggle('is-active', !isExpanded);
  }

  // 功能：清空折扣输入内容并重置错误状态
  function clearDiscountInput(clearBtn) {
    const discountArea = clearBtn.closest('.cust-cart-discount');
    const context = getDiscountContext(discountArea);
    if (!context) return;

    context.input.value = '';
    context.input.classList.remove('has-value');
    context.applyBtn.classList.remove('is-ready');
    clearInvalidState(context);
    context.input.focus();
  }

  // 功能：提交折扣码并根据购物车前后状态给出判定结果
  async function applyDiscountCode(applyBtnEl) {
    const discountArea = applyBtnEl.closest('.cust-cart-discount');
    const context = getDiscountContext(discountArea);
    if (!context || isDiscountLoading) return;

    const discountCode = context.input.value.trim();
    if (!discountCode) {
      logDiscountFlow('apply-empty-input', 'Input is empty, treat as invalid directly');
      setInvalidState(context);
      return;
    }
    if (!isValidSingleDiscountCode(discountCode)) {
      logDiscountFlow('apply-invalid-format', 'Input contains invalid discount code format', { code: discountCode });
      setInvalidState(context);
      return;
    }
    const flowId = `apply-${discountCode}-${Date.now()}`;

    try {
      setDiscountLoading(context, true);
      logDiscountFlow(flowId, 'Start applying discount code', { code: discountCode });
      const beforeCart = await requestCartSnapshot();
      const beforeCartLevelSignature = getDiscountSignature(beforeCart);
      const beforeLineLevelSignature = getLineLevelDiscountSignature(beforeCart);
      const beforeDiscountTotal = getDiscountTotal(beforeCart);
      const beforeCodes = getDiscountCodeList(beforeCart);
      const nextCodes = mergeDiscountCodes(beforeCodes, discountCode);
      const normalizedCode = discountCode.toLowerCase();
      logDiscountFlow(flowId, 'Cart snapshot before applying', {
        cart: summarizeCart(beforeCart),
        beforeCodes: beforeCodes,
        nextCodes: nextCodes,
        beforeCartLevelSignature: beforeCartLevelSignature,
        beforeLineLevelSignature: beforeLineLevelSignature,
        beforeDiscountTotal: beforeDiscountTotal
      });

      const applyResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: nextCodes.join(',') })
      });
      const applyBody = await parseJsonSafe(applyResponse);
      logDiscountFlow(flowId, 'Apply discount request response', {
        status: applyResponse.status,
        requestOk: applyResponse.ok,
        ok: applyResponse.ok,
        redirected: applyResponse.redirected,
        url: applyResponse.url,
        cart: summarizeCart(applyBody)
      });

      const afterCart = await requestCartSnapshot();
      const afterCartLevelSignature = getDiscountSignature(afterCart);
      const afterLineLevelSignature = getLineLevelDiscountSignature(afterCart);
      const afterDiscountTotal = getDiscountTotal(afterCart);
      const afterCodes = getDiscountCodeList(afterCart);
      const hasTargetCodeAfter = includesDiscountCode(afterCodes, discountCode);
      const hadTargetCodeBefore = includesDiscountCode(beforeCodes, discountCode);

      const changedNow = (
        afterCodes.join('|') !== beforeCodes.join('|') ||
        afterCartLevelSignature !== beforeCartLevelSignature ||
        afterLineLevelSignature !== beforeLineLevelSignature ||
        afterDiscountTotal > beforeDiscountTotal
      );

      const state = !hasTargetCodeAfter
        ? 'NOT_APPLIED'
        : (!hadTargetCodeBefore ? 'NEWLY_APPLIED' : 'ALREADY_APPLIED');
      logDiscountFlow(flowId, 'Post-apply state decision', {
        state: state,
        requestOk: applyResponse.ok,
        changedNow: changedNow,
        beforeCodes: beforeCodes,
        afterCodes: afterCodes,
        hadTargetCodeBefore: hadTargetCodeBefore,
        hasTargetCodeAfter: hasTargetCodeAfter,
        normalizedCode: normalizedCode,
        before: {
          cartLevelSignature: beforeCartLevelSignature,
          lineLevelSignature: beforeLineLevelSignature,
          totalDiscount: beforeDiscountTotal
        },
        after: {
          cartLevelSignature: afterCartLevelSignature,
          lineLevelSignature: afterLineLevelSignature,
          totalDiscount: afterDiscountTotal
        },
        cart: summarizeCart(afterCart)
      });

      if (state === 'NOT_APPLIED') {
        logDiscountFlow(flowId, 'Apply failed: show invalid message');
        setDiscountLoading(context, false);
        setInvalidState(context);
      } else {
        logDiscountFlow(flowId, 'Apply success, refresh cart drawer');
        clearInvalidState(context);
        await refreshCartDrawer();
        return;
      }

      console.log(`[cust-cart-discount] ${state}`, { code: discountCode });
    } catch (error) {
      setDiscountLoading(context, false);
      setInvalidState(context);
      logDiscountFlow(flowId, 'Apply flow exception', error);
      console.log('[cust-cart-discount] /discount request error', error);
    }
  }

  // 功能：获取当前折扣区域所需的核心 DOM 元素
  function getDiscountContext(discountArea) {
    if (!discountArea) return null;
    const input = discountArea.querySelector('.cust-cart-discount__input');
    const messageEl = discountArea.querySelector('.cust-cart-discount__message');
    const inputGroup = discountArea.querySelector('.cust-cart-discount__input-group');
    const applyBtn = discountArea.querySelector('.cust-cart-discount__apply');
    const loadingEl = discountArea.querySelector('.cust-cart-discount__loading');
    if (!input || !messageEl || !inputGroup || !applyBtn || !loadingEl) return null;
    return { input, messageEl, inputGroup, applyBtn, discountArea, loadingEl };
  }

  // 功能：请求购物车快照，用于前后对比折扣状态
  async function requestCartSnapshot() {
    const cartResponse = await fetch(`/cart.js?_t=${Date.now()}`, {
      method: 'GET',
      credentials: 'same-origin'
    });
    return cartResponse.json();
  }

  async function refreshCartDrawer() {
    closeAllDiscountPopups();

    const drawer = document.querySelector('#sidebar-cart');
    if (!drawer) {
      isDiscountLoading = false;

      if (
        window.theme &&
        window.theme.pageType !== 'cart' &&
        window.theme.Cart &&
        window.theme.Cart.prototype &&
        typeof window.theme.Cart.prototype._onProductAdded === 'function'
      ) {
        window.theme.Cart.prototype._onProductAdded();
        return;
      }

      window.location.reload();
      return;
    }

    const response = await fetch(`/cart?view=drawer&timestamp=${Date.now()}`, {
      method: 'GET',
      credentials: 'same-origin'
    });
    const html = await response.text();
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    const nextDrawer = tempElement.querySelector('#sidebar-cart');
    if (!nextDrawer) return;
    const currentMain = drawer.querySelector('.Drawer__Main');
    const nextMain = nextDrawer.querySelector('.Drawer__Main');
    const currentFooter = drawer.querySelector('.Drawer__Footer');
    const nextFooter = nextDrawer.querySelector('.Drawer__Footer');
    const currentHeader = drawer.querySelector('.Drawer__Header');
    const nextHeader = nextDrawer.querySelector('.Drawer__Header');

    const currentScrollPosition = currentMain ? currentMain.scrollTop : 0;

    if (currentHeader && nextHeader) {
      currentHeader.innerHTML = nextHeader.innerHTML;
    }

    if (currentMain && nextMain) {
      currentMain.innerHTML = nextMain.innerHTML;
      currentMain.scrollTop = currentScrollPosition;
    }

    if (currentFooter && nextFooter) {
      currentFooter.innerHTML = nextFooter.innerHTML;
    }

    const nextSettings = nextDrawer.getAttribute('data-section-settings');
    if (nextSettings) {
      drawer.setAttribute('data-section-settings', nextSettings);
    }

    const headerCartCount = document.querySelector('.header_cart_count');
    const headerTotalPriceEl = document.querySelector('.cart_total_price');
    const sectionSettings = nextDrawer.getAttribute('data-section-settings');

    if (sectionSettings) {
      try {
        const cartResult = JSON.parse(sectionSettings);
        if (headerCartCount) {
          headerCartCount.textContent = cartResult.itemCount;
          headerCartCount.classList.toggle('hide', !(cartResult.itemCount > 0));
        }
        if (headerTotalPriceEl && window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
          headerTotalPriceEl.textContent = window.theme.Currency.formatMoney(cartResult.totalPrice, window.theme.moneyFormat);
        }
      } catch (error) {
        console.log('[cust-cart-discount] parse cart drawer settings error', error);
      }
    }

    ensureDiscountAreaExpanded(drawer);
    markAutomaticDiscountItems(drawer);
    isDiscountLoading = false;
    drawer.classList.add('show');
    document.body.classList.add('show_overlay');
  }

  function closeAllDiscountPopups() {
    const popups = document.querySelectorAll('.cust-cart-discount__popup');
    popups.forEach(function(popup) {
      popup.style.display = 'none';
      if (popup.__originalParent && popup.parentElement === document.body) {
         popup.__originalParent.appendChild(popup);
      }
    });
  }

  function setDiscountLoading(context, isLoading) {
    if (!context || !context.discountArea || !context.loadingEl) return;

    isDiscountLoading = isLoading;
    context.discountArea.classList.toggle('is-loading', isLoading);
    context.loadingEl.style.display = isLoading ? 'flex' : 'none';
    context.loadingEl.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
    context.input.disabled = isLoading;
    context.applyBtn.disabled = isLoading;
  }

  /** InsCoder WANG.J 2026-04-15 B + Keep discount area expanded after cart drawer refresh **/
  function ensureDiscountAreaExpanded(scope) {
    const root = scope || document;
    const discountArea = root.querySelector('.cust-cart-discount');
    if (!discountArea) return;

    const content = discountArea.querySelector('.cust-cart-discount__content');
    if (!content) return;

    content.style.display = 'flex';
    discountArea.classList.add('is-active');
  }
  /** InsCoder WANG.J 2026-04-15 E + Keep discount area expanded after cart drawer refresh **/

  /** InsCoder WANG.J 2026-04-15 B + Mark automatic discount items after cart drawer refresh **/
  function markAutomaticDiscountItems(scope) {
    const root = scope || document;
    const discountItems = root.querySelectorAll('.cust-cart-applied-discount-item');
    if (!discountItems.length) return;

    discountItems.forEach(function(item) {
      const isAutomatic = item.getAttribute('data-is-automatic') === 'true';
      item.classList.toggle('cust-cart-applied-discount-item--automatic', isAutomatic);
    });
  }
  /** InsCoder WANG.J 2026-04-15 E + Mark automatic discount items after cart drawer refresh **/

  function summarizeCart(cart) {
    if (!cart) return null;
    const cartLevelDiscounts = Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [];
    const lineLevelTitles = [];
    if (Array.isArray(cart.items)) {
      cart.items.forEach(function(item) {
        if (!Array.isArray(item.line_level_discount_allocations)) return;
        item.line_level_discount_allocations.forEach(function(allocation) {
          const discountApplication = allocation && allocation.discount_application ? allocation.discount_application : null;
          if (discountApplication && discountApplication.title) {
            lineLevelTitles.push(String(discountApplication.title));
          }
        });
      });
    }
    return {
      totalDiscount: getDiscountTotal(cart),
      cartLevelDiscountCount: cartLevelDiscounts.length,
      cartLevelDiscountTitles: cartLevelDiscounts.map(function(discount) {
        return discount && discount.title ? String(discount.title) : '';
      }).filter(Boolean),
      lineLevelDiscountCount: lineLevelTitles.length,
      lineLevelDiscountTitles: lineLevelTitles,
      discountCodes: getDiscountCodeList(cart)
    };
  }

  async function parseJsonSafe(response) {
    try {
      return await response.clone().json();
    } catch (e) {
      return null;
    }
  }

  function logDiscountFlow(flowId, message, payload) {
    if (typeof payload === 'undefined') {
      console.log(`[cart-discount][${flowId}] ${message}`);
      return;
    }
    console.log(`[cart-discount][${flowId}] ${message}`, payload);
  }

  function hasDiscountCodes(cart) {
    return getDiscountCodeList(cart).length > 0;
  }

  function getDiscountCodeList(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return [];
    return cart.discount_codes.map(function(codeItem) {
      if (typeof codeItem === 'string') return codeItem;
      if (codeItem && codeItem.code) {
        // Shopify may return historical/invalid codes with applicable=false.
        // Keep only currently applicable codes for next update.js submissions.
        if (codeItem.applicable === false) return '';
        return String(codeItem.code);
      }
      return '';
    }).filter(Boolean);
  }

  function includesDiscountCode(codeList, targetCode) {
    const normalizedTarget = normalizeDiscountCode(targetCode);
    if (!normalizedTarget) return false;
    return Array.isArray(codeList) && codeList.some(function(code) {
      return normalizeDiscountCode(code) === normalizedTarget;
    });
  }

  function mergeDiscountCodes(existingCodes, incomingCode) {
    const mergedCodes = Array.isArray(existingCodes) ? existingCodes.slice() : [];
    if (!includesDiscountCode(mergedCodes, incomingCode)) {
      mergedCodes.push(String(incomingCode));
    }
    return mergedCodes.filter(Boolean);
  }

  function removeSingleCodeFromList(existingCodes, targetCode) {
    const result = {
      remainingCodes: Array.isArray(existingCodes) ? existingCodes.slice() : [],
      removedCodes: []
    };
    const normalizedTarget = normalizeDiscountCode(targetCode);
    if (!normalizedTarget) return result;

    let removedOnce = false;
    result.remainingCodes = result.remainingCodes.filter(function(code) {
      const matched = !removedOnce && normalizeDiscountCode(code) === normalizedTarget;
      if (matched) {
        result.removedCodes.push(code);
        removedOnce = true;
      }
      return !matched;
    });
    return result;
  }

  function resolveRemoveTargetCode(removeBtn, beforeCodeList) {
    const discountItem = removeBtn.closest('.cust-cart-applied-discount-item');
    if (!discountItem) return '';

    const directCode = discountItem.getAttribute('data-discount-code');
    if (directCode && includesDiscountCode(beforeCodeList, directCode)) {
      return directCode;
    }

    const removeTargetName = discountItem
      .querySelector('.cust-cart-applied-discount-name')
      ?.textContent
      ?.trim() || '';
    if (includesDiscountCode(beforeCodeList, removeTargetName)) {
      return removeTargetName;
    }

    return '';
  }

  function normalizeDiscountCode(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isValidSingleDiscountCode(discountCode) {
    if (discountCode.indexOf(',') > -1) return false;
    return /^[A-Za-z0-9_-]+$/.test(discountCode);
  }

  // 功能：设置无效折扣提示和错误样式
  function setInvalidState(context) {
    context.inputGroup.classList.add('has-error');
    showMessage(context.messageEl, INVALID_CODE_MESSAGE, 'error');
  }

  // 功能：清除错误提示和错误样式
  function clearInvalidState(context) {
    context.inputGroup.classList.remove('has-error');
    showMessage(context.messageEl, '', '');
  }

  // 功能：控制提示文案显示/隐藏与状态样式
  function showMessage(el, text, type) {
    if (!el) return;
    if (!text) {
      el.style.display = 'none';
      el.textContent = '';
      el.className = 'cust-cart-discount__message';
      return;
    }
    el.textContent = text;
    el.className = `cust-cart-discount__message is-${type}`;
    el.style.display = 'block';
  }

  // 功能：生成购物车级折扣签名，便于对比折扣变化
  function getDiscountSignature(cart) {
    if (!cart || !Array.isArray(cart.cart_level_discount_applications)) return '';
    return cart.cart_level_discount_applications.map(function(discount) {
      const title = discount && discount.title ? String(discount.title) : '';
      const amount = discount && typeof discount.total_allocated_amount !== 'undefined' ? String(discount.total_allocated_amount) : '';
      return `${title}::${amount}`;
    }).join('|');
  }

  // 功能：生成商品级折扣签名，识别商品折扣是否变化
  function getLineLevelDiscountSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return '';
    return cart.items.map(function(item) {
      if (!Array.isArray(item.line_level_discount_allocations)) return '';
      return item.line_level_discount_allocations.map(function(allocation) {
        const discountApplication = allocation && allocation.discount_application ? allocation.discount_application : null;
        const title = discountApplication && discountApplication.title ? String(discountApplication.title) : '';
        const amount = allocation && typeof allocation.amount !== 'undefined' ? String(allocation.amount) : '';
        return `${title}::${amount}`;
      }).join('|');
    }).join('||');
  }

  // 功能：获取购物车折扣总额，作为判定补充维度
  function getDiscountTotal(cart) {
    if (!cart) return 0;
    if (typeof cart.total_discount === 'number') return cart.total_discount;
    return 0;
  }
   
  
})();
/** InsCoder 2026-04-03 E + Custom cart discount logic with event delegation **/
